import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import type { RouterType } from 'commons/modules/routers/routes';

import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';

const Operation = lazy(() => import('views/Operation'));

const routers: RouterType[] = [
  {
    path: '/archivos/operacion',
    component: Operation,
    exact: true,
    menuKey: MENU_KEYS.administrationManagement,
    screenKey: SCREENS_KEYS.operation,
    breadcrumbs: {
      title: 'Operación',
      routes: [createRouteItem('Home', '/')],
    },
  },
];

export default routers;
